<template>
  <div>
    <div class="text-left">
      <b-col lg="12" md="3" class="text-left">
        <router-link :to="{ name: 'Metas' }">
          <b-button pill variant="info" class="col-lg-4">بازگشت</b-button>
        </router-link>
      </b-col>

    </div>

    <form @submit.prevent="onSubmit">
      <b-row>
        <b-col lg="6" md="12">
          <form-group :validations="$v.form.meta_name">
            <div slot-scope="{ errors, invalid }">
              <label for="" class="mt-3"> نام </label>
              <b-form-input v-model="form.meta_name"></b-form-input>

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>
        </b-col>

        <b-col lg="6" md="12">
          <form-group :validations="$v.form.meta_key">
            <div slot-scope="{ errors, invalid }">
              <label for="" class="mt-3"> وضعیت </label>
              <b-form-input
                  v-model="form.meta_key"
                  placeholder=""
              ></b-form-input>

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>
        </b-col>

        <b-col lg="6" md="12">
          <form-group :validations="$v.form.meta_type">
            <div slot-scope="{ errors, invalid }">
              <label for="" class="mt-4"> نوع </label>
              <b-form-select
                  v-model="form.meta_type"
                  :options="meta_type_options"
              ></b-form-select>
              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>
        </b-col>

        <b-col lg="6" md="12">
          <form-group :validations="$v.form.meta_value">
            <div slot-scope="{ errors, invalid }">
              <label for="" class="mt-4"> مقدار </label>
              <b-form-input
                  v-model="form.meta_value"
                  placeholder=""
              ></b-form-input>

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>
        </b-col>

      </b-row>

      <b-col class="text-center">
        <b-btn variant="info" pill class="col-lg-8 my-5" type="submit">
          ثبت
        </b-btn>
      </b-col>
    </form>
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import FormGroup from "../../validator/FormGroup";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";

export default {
  data() {
    return {
      selected: null,

      meta_type_options: [
        {value: null, text: "لطفا یک نوع را انتخاب کنید"},
        {value: "category", text: "دسته بندی"},
        {value: "order", text: "سفارش"},
        {value: "ticket", text: "پیام"},
        {value: "brand", text: "برند"},
     {value: "product", text: "محصول"},
      ],

      form: {
        meta_name: "",
        meta_key: "",
        meta_value: "",
        meta_type: "",
        custom_meta_value: "",
      },
    };
  },
  components: {FormGroup, FormErrorsManager},
  props: ["submitFunction"],
  validations: {
    form: {
      meta_name: {required},
      meta_key: {required},
      meta_type: {required},
      meta_value: {required},
    },
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {
        const form = this.form
        this.submitFunction(form)
      }
    },
  },

  mounted() {
    const router_id = this.$route.params.meta;
    if (router_id != undefined) {
      const meta= {id: router_id}
      this.$store.dispatch('Meta/showMeta', meta).then(res => {

        const data = res.data.data
        this.form.meta_name = data.name
        this.form.meta_key = data.meta_key
        this.form.meta_value = data.value
        this.form.meta_type = data.metaable_type
      })
    }
  },
};
</script>
